import React from 'react';
import '../styles/globalpresence.css'
import AnimatedArrowButton from './AnimatedArrowButton';
import icon from '../assets/location-icon.png';
import { useLocation } from 'react-router-dom';

const GlobalPresence = () => {
  const location = useLocation();
    const value = location.pathname=='/Robotics-Contact'?true:false;


    return(
        <div className='globalpresence'>
        
        <div style={{padding:'2rem',paddingBottom:'0px'}}><h4 style={{color:'#FFD52B', fontSize:'1.3rem'}}>Global Presence</h4></div>
        <hr></hr>
        <div style={{padding:'2rem'}}>
        <h1 style={{fontWeight:'700',marginBottom:'1.5rem'}}>Our Global Reach</h1>
        <p style={{fontSize:'0.9rem', color:'white'}}>Connecting industries worldwide with innovative<br></br> robotics solutions.</p>
        {value?(<></>):(<div style={{marginTop:'1.5rem',marginBottom:'2rem'}} ><AnimatedArrowButton text='Contact Us' link='Robotics-Contact' /></div>)}
        </div>
        <div className='globalpresence-container'>
        <div className="row">
        <div className="col-md-3 col-12">
          <div className="p-2">
            <div style={{display:'flex',justifyContent:'start',alignItems:'center',marginBottom:'0.7rem'}}><img src={icon} height='30px' width='30px'></img><div><p style={{color:'white',margin:'0px',marginLeft:'0.5rem',fontWeight:'500'}}>UAE </p><p className='gp-p'  style={{color:'#FFD52B',margin:'0px',marginLeft:'0.3rem'}}></p></div></div>
            <p className=''  style={{color:'#FFD52B',margin:'0px'}}>Company Six Robotics Systems LLC</p>
            <p style={{color:'white',fontSize:'0.8rem',marginBottom:'0.4rem'}}>1602 & 1603 Abdullah Bin Darwesh Building, Salam & Hamdan Street Junction, Abu Dhabi</p>
            <h5 style={{fontSize:'0.9rem'}}>Phone: +971 2 6811812</h5>
          </div>
          <div className="p-2">
            <p className=''  style={{color:'#FFD52B',margin:'0px'}}>Co 6 Horeca Foodstuff Trading LLC</p>
            <p style={{color:'white',fontSize:'0.8rem',marginBottom:'0.4rem'}}>1602 & 1603 Abdullah Bin Darwesh Building, Salam & Hamdan Street Junction, Abu Dhabi</p>
            <h5 style={{fontSize:'0.9rem'}}>Phone: +971 2 6811812</h5>
          </div>
        </div>
        <div className="col-md-3 col-12">
          <div className="p-2 ">
          <div style={{display:'flex',justifyContent:'start',alignItems:'center',marginBottom:'0.7rem'}}><img src={icon} height='30px' width='30px'></img><div><p style={{color:'white',margin:'0px',marginLeft:'0.5rem',fontWeight:'500'}}>USA </p><p className='gp-p' style={{color:'#FFD52B',margin:'0px',marginLeft:'0.3rem'}}></p></div></div>
          <p className=''  style={{color:'#FFD52B',margin:'0px'}}>Company Six Robotics</p>
            <p style={{color:'white',fontSize:'0.8rem',marginBottom:'0.4rem'}}>700 Louisiana Street, Suite 3950,
            Houstan, TX 77002, United State</p>
            <h5 style={{fontSize:'0.9rem'}}>Phone: +1 832 3902794</h5>
          </div>
        </div>
        <div className="col-md-3 col-12">
          <div className="p-2">
          <div style={{display:'flex',justifyContent:'start',alignItems:'center',marginBottom:'0.7rem'}}><img src={icon} height='30px' width='30px'></img><div><p style={{color:'white',margin:'0px',marginLeft:'0.5rem',fontWeight:'500'}}>MALAYSIA </p><p className='gp-p'  style={{color:'#FFD52B',margin:'0px',marginLeft:'0.3rem'}}></p></div></div>
          <p  className=''  style={{color:'#FFD52B',margin:'0px'}}>Company Six HORECA Sdb Bhd</p>
            <p style={{color:'white',fontSize:'0.8rem',marginBottom:'0.4rem'}}>Level 33, IIham TowerNo. 8, Jalan Binjai, Kuala Lumpur</p>
            <h5 style={{fontSize:'0.9rem'}}>Phone: +60 3 21175180</h5>
          </div>
        </div>
        <div className="col-md-3 col-12">
          <div className="p-2">
          <div style={{display:'flex',justifyContent:'start',alignItems:'center',marginBottom:'0.7rem'}}><img src={icon} height='30px' width='30px'></img><div><p style={{color:'white',margin:'0px',marginLeft:'0.5rem',fontWeight:'500'}}>JAPAN </p><p className='gp-p'  style={{color:'#FFD52B',margin:'0px',marginLeft:'0.3rem'}}></p></div></div>
          <p  className=''  style={{color:'#FFD52B',margin:'0px'}}>Company Six Robotics Systems LLC (Virtual office)</p>
            <p style={{color:'white',fontSize:'0.8rem',marginBottom:'0.4rem'}}>Level 32, Shinjuku Nomura Building. 1-26-2 Nishi-Shinjuku, Shinjuku-oku, Tokyo, Japan 163-0532</p>
            <h5 style={{fontSize:'1rem'}}></h5>
          </div>
        </div>
      </div>

        </div>


        </div>
    );


}

export default GlobalPresence;